import Config from '$root/Config';

const getAssetPath = (asset, modifier = '') => {
	const modifierPath = modifier ? `${modifier}/` : modifier;

	return `${Config.imagesPath}${modifierPath}${asset}`;
};

export default getAssetPath;
